import React from "react";
import { cn } from "../lib/Utils";

export function Team({
                         players,
                         teamColor,
                         isWinner,
                         isDraw,
                         result,
                         tbd,
                         match = {},
                         isRight = false,
                     }) {
    if (tbd) {
        return (
            <>
                {/* Desktop */}
                <div className="hidden sm:block w-1/2 p-4">
                    <div
                        className={cn(
                            "font-bold text-2xl text-black xl:text-4xl 2xl:text-6xl",
                            isRight && "text-right"
                        )}
                    >
                        TBD
                    </div>
                </div>
                {/* Mobile */}
                <div
                    className={cn(
                        "sm:hidden p-4",
                        isRight && "border-t border-gray-300"
                    )}
                >
                    <div className="font-bold text-xl text-black">TBD</div>
                </div>
            </>
        );
    }

    const showResult = isWinner || isDraw;
    const holeInProgress = function (match) {
        let response = "Upcoming";


        if (match.tee) {
            response += " - Tee " + match.tee
        }

        let result = match.result;
        let holeInProgress = match.holeInProgress;
        if (match.finalized || (result && !holeInProgress)) {
            response = "Final";

        } else if (holeInProgress) {
            return "Hole " + holeInProgress;
        }

        return response;
    };

    return (
        <>
            {/* Desktop */}
            <div
                className={cn(
                    "hidden sm:block w-1/2 p-4 relative overflow-visible",
                    isRight && "pl-14",
                    isWinner && `team-winner-${teamColor}`
                )}
            >
                {players.map((p, i) => (
                    <div
                        key={i}
                        className={cn(
                            "flex items-center",
                            i > 0 && "mt-2",
                            isRight ? "justify-end" : "justify-start"
                        )}
                    >
                        {isRight ? (
                            <>
                                <div className="text-right mr-2 min-w-0 max-w-[calc(100%-6rem)]">
                                    <div className="font-bold whitespace-normal xl:text-xl 2xl:text-3xl">
                                        {p.name}&nbsp;
                                    </div>
                                    <div className="font-bold whitespace-normal xl:text-xl 2xl:text-3xl">
                                        <span className="inline-block font-normal opacity-50 text-sm sm:text-xs lg:text-sm xl:text-xl 2xl:text-2xl">
                                            {p.surname}
                                        </span>
                                    </div>
                                </div>
                                <div
                                    className={cn(
                                        "w-10 h-10 rounded-full mx-3 my-2 flex items-center justify-center flex-shrink-0 xl:w-16 xl:mx-4 2xl:mx-5 xl:h-16 2xl:w-18 2xl:h-18 team-profile-green",
                                        `team-profile-${teamColor}`
                                    )}
                                >
                                    <spam className="font-bold text-white lg:text-xl xl:text-3xl opacity-80">
                                        {p.hcpj === 0
                                            ? (
                                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
                                                    <path fill="currentColor" d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2m3.23 15.39L12 15.45l-3.22 1.94a.502.502 0 0 1-.75-.54l.85-3.66l-2.83-2.45a.505.505 0 0 1 .29-.88l3.74-.32l1.46-3.45c.17-.41.75-.41.92 0l1.46 3.44l3.74.32a.5.5 0 0 1 .28.88l-2.83 2.45l.85 3.67c.1.43-.36.77-.74.54"/>
                                                </svg>
                                            )
                                            : p.hcpj
                                        }
                                    </spam>
                                </div>
                            </>
                        ) : (
                            <>
                                <div
                                    className={cn(
                                        "w-10 h-10 rounded-full mx-3 my-2 flex items-center justify-center flex-shrink-0 xl:w-16 xl:mx-4 2xl:mx-5 xl:h-16 2xl:w-18 2xl:h-18 team-profile-green",
                                        `team-profile-${teamColor}`
                                    )}
                                >
                                    <spam className="font-bold text-white lg:text-xl xl:text-3xl opacity-80">
                                        {p.hcpj === 0
                                            ? (
                                                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
                                                    <path fill="currentColor" d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2m3.23 15.39L12 15.45l-3.22 1.94a.502.502 0 0 1-.75-.54l.85-3.66l-2.83-2.45a.505.505 0 0 1 .29-.88l3.74-.32l1.46-3.45c.17-.41.75-.41.92 0l1.46 3.44l3.74.32a.5.5 0 0 1 .28.88l-2.83 2.45l.85 3.67c.1.43-.36.77-.74.54"/>
                                                </svg>
                                            )
                                            : p.hcpj
                                        }
                                    </spam>
                                </div>
                                <div className="min-w-0">
                                    <div className="font-bold whitespace-normal xl:text-xl 2xl:text-3xl">
                                        {p.name}&nbsp;
                                    </div>
                                    <div className="font-bold whitespace-normal xl:text-xl 2xl:text-3xl">
                                        <span className="inline-block font-normal opacity-50 text-sm sm:text-xslg:text-sm xl:text-xl 2xl:text-2xl">
                                            {p.surname}
                                        </span>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                ))}

                {showResult && (
                    <>
                        <div
                            className={cn(
                                "absolute inset-y-0",
                                isRight ? "left-0" : "right-0",
                                "w-2 bg-white z-10"
                            )}
                        />
                        <div
                            className={cn(
                                "absolute inset-y-0",
                                isRight ? "left-5" : "right-5",
                                "flex flex-col mb-1 items-center justify-center z-20"
                            )}
                        >
                            <div
                                className={cn(
                                    "font-bold text-2xl px-4 py-1 xl:text-2xl 2xl:text-3xl",
                                    isRight ? "rounded-l-md" : "rounded-r-md",
                                    isDraw ? "text-black bg-white" : ""
                                )}
                            >
                                {result}
                            </div>
                            <div className="text-xs xl:text-lg 2xl:text-xl opacity-60 uppercase">
                                <span>{holeInProgress(match)}</span>
                            </div>
                        </div>
                    </>
                )}
            </div>

            {/* Mobile */}
            <div
                className={cn(
                    "sm:hidden relative p-4",
                    isRight && "border-t border-gray-300 pr-12",
                    isWinner && `team-winner-${teamColor}`
                )}
            >
                {players.map((p, i) => (
                    <div
                        key={i}
                        className={cn(
                            "flex items-center",
                            i > 0 && "mt-2"
                        )}
                    >
                        <div
                            className={cn(
                                "w-8 h-8 rounded-full mr-2 flex items-center justify-center flex-shrink-0",
                                `team-profile-${teamColor}`
                            )}
                        >
                            <spam className="font-semibold text-white">
                                {p.hcpj === 0
                                    ? (
                                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
                                            <path fill="currentColor" d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2m3.23 15.39L12 15.45l-3.22 1.94a.502.502 0 0 1-.75-.54l.85-3.66l-2.83-2.45a.505.505 0 0 1 .29-.88l3.74-.32l1.46-3.45c.17-.41.75-.41.92 0l1.46 3.44l3.74.32a.5.5 0 0 1 .28.88l-2.83 2.45l.85 3.67c.1.43-.36.77-.74.54"/>
                                        </svg>
                                    )
                                    : p.hcpj
                                }
                            </spam>
                        </div>
                        <div className="min-w-0">
                            <div className="font-bold whitespace-normal">
                                {p.name}&nbsp;
                                <span className="inline-block text-sm opacity-60">
                                    {p.surname}
                                </span>
                            </div>
                        </div>
                    </div>
                ))}

                {showResult && (
                    <>
                        <div
                            className={cn(
                                "absolute inset-y-0",
                                isRight ? "left-0" : "right-0",
                                "w-1 bg-white z-10"
                            )}
                        />
                        <div className="absolute inset-y-0 right-4 flex flex-col mb-1 items-center justify-center z-20">
                            <div
                                className={cn(
                                    "font-bold text-xl px-3 py-1",
                                    isRight ? "rounded-l-md" : "rounded-r-md",
                                    isDraw ? "text-black bg-white" : ""
                                )}
                            >
                                {result}
                            </div>
                            <div className="text-xs font-bold opacity-60 uppercase">
                                <span>{holeInProgress(match)}</span>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </>
    );
}
